<template>
  <v-container>
    <v-card>
      <div class="ma-8 pa-4">
        <v-layout row wrap>
          <v-flex md4 class="">
            <v-container style="text-align: center" v-if="itemImage != ''">
              <MusicLink :amazonURL="amazonURL" :itemImage="itemImage" :buttons="buttons">
              </MusicLink>

              <v-divider class="mt-4"></v-divider>
              <div class="mt-4" v-if="audioDescription != ''">
                <div class="audioPreview" style="text-align: center">
                  AUDIO PREVIEW
                </div>
                <div class="audioDescription">{{ audioDescription }}</div>
                <slot name="video"> </slot>
              </div>
              <div
                style="text-align: left"
                class="mt-2"
                v-if="sampleAudio != ''"
              >
                Samples:
                <div v-for="audio in sampleAudio" v-bind:key="audio">
                  <div class="text-left mb-4 ml-2 ma-2 d-block">
                    {{ audio.title }}
                    <audio style="width: 100%" controls class="d-block">
                      <source :src="audio.source" type="audio/mp3" />
                    </audio>
                  </div>
                </div>
              </div>
            </v-container>
            <div v-else id="comingSoon" class="text-xs-center">???</div>
          </v-flex>
          <!-- <v-flex class="{'mx-4': $vuetify.breakpoint.smAndUp}" md8> -->
          <v-flex md8>
            <div class="mt-2 mx-1" style="height: 100%; max-width: 700px">
              <h2 id="title">{{ title }}</h2>
              <h4 class="mb-2 mt-1">{{ subtitle }}</h4>
              <h5>by {{ author }}</h5>
              <v-divider class="mt-3"></v-divider>
              <p id="description" class="my-3"></p>
              <p style="font-size: 16px"><slot name="description"></slot></p>
              <p id="subtext" class="my=3">{{ subtext }}</p>
              <v-divider></v-divider>
              <v-layout align-end class="mt-3" style="display: inline">
                <!-- <v-flex> -->
                <p v-if="link != ''">
                  <!-- <button :onclick="this.router.push(link)">View on Amazon</button> -->
                  <!-- <a :href="link">View on Amazon</a> -->
                </p>
                <p v-else>Coming Soon!</p>

                <div v-if="images.length != 0">
                  <div class="copyrightNotice">(copyrighted material)</div>
                  <div class="mr-4">Preview of book:</div>

                  <div
                    class="bookImage text-xs-center hidden-xs-only"
                    v-for="(image, i) in images"
                    :key="i"
                  >
                    <img width="60%" :src="image" />
                  </div>
                  <div
                    class="bookImage text-xs-center hidden-sm-and-up"
                    v-for="(image, i) in images"
                    :key="i"
                  >
                    <img width="100%" :src="image" />
                  </div>
                </div>
                <!-- </v-flex> -->
              </v-layout>
              <MusicButtons :buttons=buttons></MusicButtons>
            </div>
            <!-- <v-divider></v-divider> -->
          </v-flex>

          <v-flex mt-3>
            <Chapter
              v-for="chapter in chapters"
              v-bind:key="chapter"
              :title="chapter.title"
              :link="chapter.link"
              :image="chapter.image"
            >
            </Chapter>
          </v-flex>
        </v-layout>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import MusicLink from "./MusicLink";
import Chapter from "./Chapter";
import MusicButtons from "./MusicButtons.vue";

export default {
  name: "MusicBook",
  props: {
    title: String,
    subtitle: String,
    author: String,
    description: String,
    subtext: String,
    link: String,
    images: Array,
    sampleAudio: Array,
    audioDescription: String,
    amazonURL: String,
    itemImage: String,
    buttons: Array,
    chapters: Array,
  },

  components: {
    MusicLink,
    Chapter,
    MusicButtons
  },
  mounted() {},
};
</script>

<style>
.audioPreview {
  font-size: 14px;
  font-weight: bold;
}

.audioDescription {
  margin-bottom: 10px;
  font-weight: 300;
}

#comingSoon {
  font-size: 32px;
}
#description {
  font-size: 18px;
  white-space: pre-line;
}
#subtext {
  font-size: 12px;
}

.copyrightNotice {
  /* position: absolute;
  right: 1%;
  top: -5%; */
  display: inline;
  font-size: 8px;
  font-weight: 200;
  text-align: right;
}

.bookImage {
  /* transition: transform .3s; */
  display: inline-block;
  /* width: 33.33%;   */
}

/* .bookImage:hover {

  transform: scale(2);
} */
</style>